import { render, staticRenderFns } from "./Choice.vue?vue&type=template&id=024f8a98&scoped=true&"
import script from "./Choice.vue?vue&type=script&lang=js&"
export * from "./Choice.vue?vue&type=script&lang=js&"
import style0 from "./Choice.vue?vue&type=style&index=0&id=024f8a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f8a98",
  null
  
)

export default component.exports